import { Component  } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'renci-popup-login',
  templateUrl: './login-in-progress.component.html',
  styleUrls: ['./login-in-progress.component.css']
})
export class LoginInProgressComponent {

  public error: string = null;

  public authWindow: Window = null;

  constructor(public activeModal: NgbActiveModal) {
  }
}
